// extracted by mini-css-extract-plugin
export default {"contentWidth":"glLhFE9tMwEGmLi5a3Fi","screen":"mwtLZ34REG7Vy5qtwfZk UeY_FN1IuF72KeoJFYFT","buttons":"Bw2LjDRku3yAhHziczxm A9Unjtc9wpC1sbeHDTY4"};